//removeIf(production)
import FloatWithTwoDecimals from "./float-with-two-decimals";
//endRemoveIf(production)

class ClaroluzEnergy {
    public value: number;
    public price: number;

    constructor({ value, price }: { value: number; price: number; },) {
        this.value = value;
        this.price = new FloatWithTwoDecimals(price).value;
    }
}

//removeIf(production)
export default ClaroluzEnergy;
//endRemoveIf(production)